module.exports = __webpack_public_path__ + "static/media/15.7bf407af.jpg";